import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './../../assets/logo.svg'


const _hoisted_1 = { class: "navbar app-nav" }
const _hoisted_2 = { class: "container shadow-dark bg-white rounded" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Geosite"
}, null, -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "d-flex align-c mobile-actions" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<i class=\"icon menu\"><svg xmlns=\"http://www.w3.org/2000/svg\" height=\"100%\" width=\"100%\" viewBox=\"0 0 20 20\" class=\"svg-fill\"><rect x=\"1.06\" y=\"3.35\" width=\"17.87\" height=\"2.02\" rx=\"1.01\"></rect><rect x=\"1.06\" y=\"8.99\" width=\"17.87\" height=\"2.02\" rx=\"1.01\"></rect><rect x=\"1.06\" y=\"14.63\" width=\"17.87\" height=\"2.02\" rx=\"1.01\"></rect></svg></i>", 1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_lang_select = _resolveComponent("lang-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("nav", {
        class: _normalizeClass({'active': $setup.active})
      }, [
        _createElementVNode("a", {
          class: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggle(false)))
        }, [
          _createVNode(_component_v_icon, { icon: "close" })
        ]),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.route('/#faq'))),
          class: "link",
          innerHTML: $setup.strings.core['F.A.Q.']
        }, null, 8, _hoisted_5),
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.route('/pricing'))),
          class: "link",
          innerHTML: $setup.strings.core['Pricing']
        }, null, 8, _hoisted_6),
        _createElementVNode("a", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.route('/contact'))),
          class: "link",
          innerHTML: $setup.strings.core['Contact']
        }, null, 8, _hoisted_7),
        _createElementVNode("a", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.route('/cc'))),
          class: "link",
          innerHTML: $setup.strings.core['Unsubscribe']
        }, null, 8, _hoisted_8),
        _createVNode(_component_lang_select, { class: "link" }),
        (!$setup.access)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.route('/login'))),
              class: "btn bg-primary",
              slot: "nav"
            }, [
              _createElementVNode("span", null, _toDisplayString($setup.strings.core["Login"]), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.access)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.route('/dash'))),
              class: "btn bg-primary",
              slot: "nav"
            }, _toDisplayString($setup.strings.core["Dashboard"]), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_lang_select, { class: "mobile" }),
        _createElementVNode("a", {
          class: "toggle",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.toggle(true)))
        }, _hoisted_11)
      ])
    ])
  ]))
}